var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail2Icon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4764_1362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9098 3.46587C15.9098 3.44871 15.9216 3.432 15.9209 3.41504L11.3418 7.83108L15.9154 12.1061C15.918 12.0755 15.9098 12.0447 15.9098 12.0135V3.46587Z",
    fill: "#F9862F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6424 8.51074L8.77261 10.3108C8.678 10.4019 8.5558 10.4476 8.43353 10.4476C8.31381 10.4476 8.19409 10.4039 8.10012 10.3162L6.23544 8.57756L1.63086 13.0187C1.74282 13.0589 1.863 13.0902 1.98885 13.0902H14.8783C15.0652 13.0902 15.2404 13.0332 15.3928 12.9483L10.6424 8.51074Z",
    fill: "#F9862F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42609 9.28463L15.4161 2.54696C15.2578 2.45281 15.0736 2.38965 14.8762 2.38965H1.98675C1.72964 2.38965 1.49404 2.48954 1.31055 2.6419L8.42609 9.28463Z",
    fill: "#F9862F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.912109 3.62988V12.0133C0.912109 12.1096 0.934209 12.2023 0.9582 12.291L5.50454 7.90916L0.912109 3.62988Z",
    fill: "#F9862F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4764_1362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.0099,
    height: 15.0183,
    fill: "white",
    transform: "translate(0.912109 0.230469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail2Icon);
export default __webpack_public_path__ + "static/media/email2Icon.7654fcf108a63c6ebaefab0ce19b3dc4.svg";
export { ForwardRef as ReactComponent };